// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e44f869e","453":"85a33980","455":"126817af","977":"75926caa"}[chunkId] + ".chunk.js";
};